import { render, staticRenderFns } from "./CellForm.vue?vue&type=template&id=8ad4c0f8&scoped=true"
import script from "./CellForm.vue?vue&type=script&lang=js"
export * from "./CellForm.vue?vue&type=script&lang=js"
import style0 from "./CellForm.vue?vue&type=style&index=0&id=8ad4c0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad4c0f8",
  null
  
)

export default component.exports